import { gql } from "@apollo/client";

export const READ_SYSTEM_NOTICE = gql`
mutation ReadSystemNotice($where: SystemNoticeWhereInputOne!) {
  readSystemNotice(where: $where) {
    message
  }
}
`


